
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lon/mining/trade",
      function () {
        return require("private-next-pages/lon/mining/trade/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lon/mining/trade"])
      });
    }
  